import React from 'react';
import { Building, Calendar, Image } from 'lucide-react';

const WelcomeStep = ({ onNext }) => {
    const features = [
        { icon: <Building size={20} />, title: 'Företagsuppgifter', desc: 'Lägg till kontaktuppgifter för ditt företag' },
        { icon: <Calendar size={20} />, title: 'Räkenskapsår', desc: 'Skapa ditt första räkenskapsår eller importera SIE-fil' },
        { icon: <Image size={20} />, title: 'Logotyp', desc: 'Ladda upp din logotyp för fakturor och offerter' },
    ];

    return (
        <>
            <style>{`
                .welcome-step {
                    text-align: center;
                    padding: 1rem 0;
                }
                .welcome-title {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #1e293b;
                    margin-bottom: 0.5rem;
                }
                .welcome-subtitle {
                    font-size: 0.95rem;
                    color: #64748b;
                    margin-bottom: 2rem;
                    max-width: 450px;
                    margin-left: auto;
                    margin-right: auto;
                }
                .welcome-features {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    max-width: 400px;
                    margin: 0 auto 2rem;
                    text-align: left;
                }
                .welcome-feature {
                    display: flex;
                    align-items: flex-start;
                    gap: 1rem;
                    padding: 1rem;
                    border-radius: 12px;
                    background: #f8fafc;
                    border: 1px solid #f1f5f9;
                }
                .welcome-feature-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--primary);
                    flex-shrink: 0;
                    border: 1px solid #e2e8f0;
                }
                .welcome-feature-title {
                    font-weight: 600;
                    font-size: 0.875rem;
                    color: #1e293b;
                    margin-bottom: 0.125rem;
                }
                .welcome-feature-desc {
                    font-size: 0.8rem;
                    color: #64748b;
                    margin: 0;
                }
                .welcome-start-btn {
                    background: var(--primary);
                    border: none;
                    color: white;
                    padding: 0.75rem 2.5rem;
                    border-radius: 10px;
                    font-weight: 600;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: all 0.15s;
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                }
                .welcome-start-btn:hover {
                    opacity: 0.9;
                    transform: translateY(-1px);
                }
            `}</style>
            <div className="welcome-step">
                <h2 className="welcome-title">Välkommen till LedgerLoop!</h2>
                <p className="welcome-subtitle">
                    Låt oss konfigurera ditt företag på ett par minuter. Vi guidar dig genom de viktigaste stegen för att komma igång.
                </p>
                <div className="welcome-features">
                    {features.map((feature, i) => (
                        <div className="welcome-feature" key={i}>
                            <div className="welcome-feature-icon">{feature.icon}</div>
                            <div>
                                <div className="welcome-feature-title">{feature.title}</div>
                                <p className="welcome-feature-desc">{feature.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="welcome-start-btn" onClick={onNext}>
                    Kom igång
                </button>
            </div>
        </>
    );
};

export default WelcomeStep;
